import React from 'react';
import { GiCheckMark } from "react-icons/gi";


export default function Component(props) {

  const { question, answersList, surveyLanguageCode, handleRadio, clicked, surveyScreenData, isArabic } = props;

  return (
    <>
      {/* <div className={isArabic ? "" : "flex justify-center pt-6"}>

        <div className={isArabic ? "grid md:grid-cols-1 grid-cols-1 gap-4 md:px-6 px-4 sm:px-40 md:px-16 lg:px-16 xl:px-16 2xl:px-16" : "grid md:grid-cols-1 grid-cols-1 gap-4 md:px-6 px-4 sm:px-40 md:px-40 lg:px-30 xl:px-32 2xl:px-40"}>
          {question && question.optionsList && question.optionsList.length > 0 ?
            question.optionsList.map((option, optionindex) =>
              <button
                style={{
                  margin: '7px',
                  borderWidth: '2px',
                  color: (answersList.some(item => option.id === item.questionOptionId)) || (clicked === option.id) ? surveyScreenData && surveyScreenData.OptionColor2 ? surveyScreenData.OptionColor2 : 'black' : (surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : "#757575",
                  background: (answersList.some(item => option.id === item.questionOptionId)) || (clicked === option.id) ? (surveyScreenData && surveyScreenData.OptionColor3) ? surveyScreenData.OptionColor3 : "#757575" : (surveyScreenData && surveyScreenData.OptionColor1) ? surveyScreenData.OptionColor1 : '#757575',
                  fontSize: '15px',
                  fontWeight: 'bold'
                }}
                onClick={() => handleRadio(optionindex, question, option)}
                className="w-72 md:w-96 lg:w-96 xl:w-96 ml-10 bg-white-1t p-2 rounded-lg text-center md:text-md text-md border border-gray-500" >{(surveyLanguageCode !== '') ?
                  (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id]) ?
                    question.transl[surveyLanguageCode].optionsList[option.id] : option.name

                  : option.name}</button>
            ) : null}
        </div>

      </div> */}

      <div className={isArabic ? "" : "flex justify-center pt-6 2xl:w-4/5 xl:w-1/2 lg:w-11/12"}>
        <div className={isArabic ? "w-full space-y-4" : "space-y-4 w-full"}>
          {question?.optionsList?.length > 0 &&
            question.optionsList.map((option, optionindex) => {

              const isSelected =
                answersList.some(item => option.id === item.questionOptionId) ||
                clicked === option.id;

              const textColor = isSelected
                ? surveyScreenData?.optionTextActiveColor || "#FFFFFF"
                : surveyScreenData?.optionTextColor || "#FFFFFF";

              const bgColor = isSelected
                ? surveyScreenData?.optionBgActiveColor || "#5ACC66"
                : surveyScreenData?.optionBgColor || "#3B92D4";

              const borderColor = isSelected
                ? surveyScreenData?.optionBorderActiveColor || "#5ACC66"
                : surveyScreenData?.optionBorderColor || "#3B92D4";


              return (
                <button
                  key={optionindex}
                  style={{ color: textColor, background: bgColor, borderColor: borderColor }}
                  onClick={() => handleRadio(optionindex, question, option)}
                  className="w-full py-2 px-4 rounded-md text-center text-base flex justify-between items-center border font-medium"
                >
                  {/* -------- Option Text -------- */}
                  {(surveyLanguageCode !== '') ?
                    (question?.transl?.[surveyLanguageCode]?.optionsList?.[option.id]) ?
                      question.transl[surveyLanguageCode].optionsList[option.id] : option.name
                    : option.name}

                  {/* -------- Check Icon -------- */}
                  {isSelected && <GiCheckMark size={22} />}
                </button>
              );
            })}
        </div>
      </div>




    </>
  );
}